/*
 * File: UILinkList.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 11/12/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates a list of links using the passed in links array.
 *    Objects in the list array can have primary text, secondary text, and a URL
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { List } from "@material-ui/core";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import UILinkListItem from "./UILinkListItem";

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5)
  },
  fabSpacing: {
    height: theme.spacing(6)
  }
});

const UILinkList = ({ links, classes, includeArrow = true }) => {
  const linkElements = links.map((link, idx) => {
    const id = "link-" + idx;
    if (link.url) {
      return (
        <Link to={link.url} key={idx} id={id}>
          <UILinkListItem includeArrow={includeArrow} link={link} />
        </Link>
      );
    } else {
      return (
        <UILinkListItem key={idx} includeArrow={includeArrow} link={link} />
      );
    }
  });

  return (
    <List className={classes.root}>
      {linkElements}
      <div className={classes.fabSpacing} />
    </List>
  );
};

UILinkList.propTypes = {
  links: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  includeArrow: PropTypes.bool,
  includeFabPadding: PropTypes.bool
};

export default withStyles(styles)(UILinkList);
